module.exports = __webpack_public_path__ + "static/media/texture.4a3619ef.jpg";